import { useQuery } from "react-query";
import { ChampionshipAgeGroupAPI } from "api/admin/championshipAgeGroup";
import { CHAMPIONSHIP_AGE_GROUPS } from "helpers/constants";

export default function useChampionshipAgeGroups(championshipId) {
  return useQuery([CHAMPIONSHIP_AGE_GROUPS, championshipId], () =>
    ChampionshipAgeGroupAPI.getAll(championshipId)
  );
}
